import httpClient from 'shared/lib/httpClient';
import { parseRoleDetail } from '../schemas/RoleSchema';

export const getRoleDetail = async (id) => {
  const response = await httpClient.get(`/company-roles/${id}`);
  return parseRoleDetail(response?.data);
};
